import { circularProgressClasses } from '@mui/material/CircularProgress';
import { linearProgressClasses } from '@mui/material/LinearProgress';

// ----------------------------------------------------------------------

/** Loading indicators keep moving: a frozen spinner reads as a hung app. */
const progressIndicators = [
  `.${circularProgressClasses.root}`,
  `.${circularProgressClasses.circle}`,
  `.${linearProgressClasses.bar}`,
].join(', ');

/**
 * Honours the OS "reduce motion" setting for every CSS transition and animation in the app —
 * MUI's drawer slides, collapses and menu grows, hover lifts, our own keyframes. They finish
 * instantly instead of being removed (0.01ms, not 0, so `transitionend`/`animationend` still
 * fire for code waiting on them). framer-motion is JS-driven and covered by `MotionConfig` in
 * `MotionLazy`; JS smooth scrolling by `scrollBehavior()` in `src/utils/motion`.
 */
export function motion() {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '@media (prefers-reduced-motion: reduce)': {
          [`*:not(${progressIndicators}), *::before, *::after`]: {
            animationDuration: '0.01ms !important',
            animationIterationCount: '1 !important',
            transitionDuration: '0.01ms !important',
            scrollBehavior: 'auto !important',
          },
        },
      },
    },
  };
}
